import React from 'react'
import { PaymentPlan } from '@/types/types'

export const PlanTotal = ({ plan }: { plan: PaymentPlan }) => {
  return (
    <div className="mt-5 bg-boxBg rounded-3xl py-5 px-6">
      <ul>
        <li className="flex justify-between gap-1 text-[14px] font-medium">
          <span>{plan.name}</span>
          <span>${plan.originalPrice}</span>
        </li>
        <li className="mt-0.5 flex justify-between gap-1 text-[14px] font-medium">
          <span>{plan.percentDiscount}% price discount</span>
          <span>-${plan.discountAmount}</span>
        </li>
      </ul>
      <div className="mt-[18px] pt-[18px] border-t border-[#101A3614] flex justify-between gap-1">
        <p className="font-semibold">Total:</p>
        <span className="font-semibold">${plan.discountedPrice}</span>
      </div>
    </div>
  )
}
